/**
 * <quantity-input> — number input with minus / plus buttons.
 * Respects the input's min, max and step, and fires a normal "change" event so forms and the cart can react.
 */
class QuantityInput extends HTMLElement {
  connectedCallback() {
    this.input = this.querySelector('input');
    this.addEventListener('click', this.onClick);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.onClick);
  }

  onClick = (event) => {
    const button = event.target.closest('[data-step]');
    if (!button || !this.input) return;
    this.step(Number(button.dataset.step));
  };

  step(direction) {
    const min = Number(this.input.min) || 1;
    const max = this.input.max ? Number(this.input.max) : Infinity;
    const current = Number(this.input.value) || min;
    const next = Math.min(max, Math.max(min, current + direction));
    if (next === current) return;

    this.input.value = String(next);
    this.input.dispatchEvent(new Event('change', { bubbles: true }));
  }
}

if (!customElements.get('quantity-input')) customElements.define('quantity-input', QuantityInput);
